import AntIcon from "@ant-design/icons"

import Utils from "../Utils/utils"
import { svg } from "./img"

const Icon = ({ type, ...props }) => {
  if (!type) return null

  const iconKey = Utils.toPascalCase(type)
  const IconComp = svg[iconKey]

  if (!IconComp) {
    console.warn("Icon not found:", type)
    return null
  }

  // Pass the component reference directly - AntIcon forwards the remaining props to it itself.
  // Wrapping it in an inline arrow (`() => <IconComp {...props} />`) made a brand-new component
  // on every render, which React (and AntIcon under it) treats as a different component type and
  // remounts - tearing down and recreating the icon's DOM node on every re-render of whatever
  // renders this Icon. When that remount landed between a pointerdown and pointerup on a button
  // using this icon, the browser silently dropped the click (the mousedown target no longer
  // existed), which is exactly what made buttons like Globe's zoom/reset controls miss clicks.
  return <AntIcon component={IconComp} {...props} />
}
export default Icon
